var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scroll-to-top", on: { click: _vm.onClick } },
    [_c("i", { staticClass: "fas fa-arrow-up" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }